import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute} from "@tanstack/react-router";
import {useRef} from "react";

export const Route = createFileRoute("/_app/sales/expedients/$expedientId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {expedientId} = Route.useParams();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate replace params={{expedientId}} to={routes.sales.expedients.expedient().options()} />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
